// extracted by mini-css-extract-plugin
module.exports = {"container":"container__1A_f-","embedded":"embedded__5WbxO","interactive":"interactive___L3o8","title":"title__1RZh9"};